import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { FormContext } from "../../../common/context/context";
import { LangHelper } from './helper';
var LangMessage = function (props) {
    var msgKey = props.msgKey, defaultValue = props.defaultValue;
    var state = React.useContext(FormContext).state;
    var _a = React.useState(defaultValue || msgKey), value = _a[0], setValue = _a[1];
    useEffect(function () {
        var langValue = LangHelper.getLangMessageValue(msgKey, state.lang, defaultValue);
        setValue(langValue);
    }, [state]);
    return (_jsx(_Fragment, { children: _jsx("span", { dangerouslySetInnerHTML: { __html: value } }) }));
};
export default LangMessage;
